import React, { useState, useEffect } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { getVideo } from '../../s3Func/s3Download';
import { DragDropContainer, DropTarget } from 'react-drag-drop-container';
import './MatchGame.scss';
import { sleep } from '../../utils';

/**
 * MatchGame component extracted from PracticeRecording
 * Handles the drag-and-drop matching game functionality
 * @param {*} props
 * @returns the HTML code for the match game section.
 */
const MatchGame = (props) => {
  // Initialize variables to be used later
  const { login } = useSelector((state) => state.loginReducer, shallowEqual);

  const [practice, setPractice] = useState(true);
  const [step, setStep] = useState(2);
  const [changeText, setChangeText] = useState('');
  const [option1, setOption1] = useState('');
  const [option2, setOption2] = useState('');
  const [option3, setOption3] = useState('');
  const [answerkey, setAnswerkey] = useState(null);
  const [titles, setTitles] = useState([
    'Step 1: Be Kind',
    'Step 2: Ask Questions',
    'How to Stop Bullying',
  ]);
  const [keyword, setKeyword] = useState('');
  const [displayIntro, setDisplayIntro] = useState(true);
  const [instruction, setInstruction] = useState('');
  const [matchGame, setMatchGame] = useState(false);
  const [matchOptions, setMatchOptions] = useState(null);
  const [matchOptionsCopy, setMatchOptionsCopy] = useState(null);
  const [order1, setOrder1] = useState(null);
  const [order2, setOrder2] = useState(null);
  const [order3, setOrder3] = useState(null);
  const [order1Visibility, setOrder1Visibility] = useState('');
  const [order2Visibility, setOrder2Visibility] = useState('');
  const [order3Visibility, setOrder3Visibility] = useState('');

  const [question, setQuestion] = useState(false);
  const [introSound, setIntroSound] = useState('');
  const [animalVoice, setAnimalVoice] = useState('');
  const [animalTalk, setAnimaTalk] = useState(false);
  const [score, setScore] = useState(0);
  const [firstTime, setFirstTime] = useState(true);

  const generateImageUrl = (baseUrl) => login.cloudFront + baseUrl + login.cookie;

  const Exit = generateImageUrl('images/Images/close.png')
  const greenCheck = generateImageUrl('images/Module1Images/GreenCheck-Button.png')

  useEffect(() => {
    initializePractice();
  }, [step]);

  const initializePractice = () => {
    const optionHelp = {
      img: generateImageUrl('images/Module17Images/practice/help him.png'),
      title: 'Help him',
      audioPrompt: 'appfiles/friends_bullying/option_help.mp3',
    };
    
    const optionSmileHi = {
        img: generateImageUrl('images/Module17Images/practice/smile and say hi.png'),
        title: 'Smile and say hi',
        audioPrompt: 'appfiles/friends_bullying/option_smile_hi.mp3',
    };
    
    const optionFrown = {
        img: generateImageUrl('images/Module17Images/practice/frown.png'),
        title: 'Frown',
        audioPrompt: 'appfiles/friends_bullying/option_frown.mp3',
    };
    
    const optionWhatLike = {
        img: generateImageUrl('images/Module17Images/practice/what do you like.png'),
        title: 'What do you like?',
        audioPrompt: 'appfiles/friends_bullying/option_what_like.mp3',
    };
    
    const optionWhySad = {
        img: generateImageUrl('images/Module17Images/practice/why are you sad.png'),
        title: 'Why are you sad?',
        audioPrompt: 'appfiles/friends_bullying/option_why_sad.mp3',
    };
    
    const optionIgnore = {
        img: generateImageUrl('images/Module17Images/practice/ignore them.png'),
        title: 'Ignore your friend',
        audioPrompt: 'appfiles/friends_bullying/option_ignore.mp3',
    };
    
    const optionWhereGoing = {
        img: generateImageUrl('images/Module17Images/practice/where are you going.png'),
        title: 'Where are you going?',
        audioPrompt: 'appfiles/friends_bullying/option_where_going.mp3',
    };
    
    const optionSorryNervous = {
        img: generateImageUrl('images/Module17Images/practice/I_m sorry you feel nervous.png'),
        title: "I'm sorry you feel nervous",
        audioPrompt: 'appfiles/friends_bullying/option_sorry_nervous.mp3',
    };
    
    const optionGiveUp = {
        img: generateImageUrl('images/Module17Images/practice/just give up.png'),
        title: 'Just give up',
        audioPrompt: 'appfiles/friends_bullying/option_give_up.mp3',
    };
    
    const optionNeverNervous = {
        img: generateImageUrl('images/Module17Images/practice/I never feel nervous.png'),
        title: 'I never feel nervous',
        audioPrompt: 'appfiles/friends_bullying/option_never_nervous.mp3',
    };
    
    const optionLikeBaseball = {
        img: generateImageUrl('images/Module17Images/practice/do you like baseball.png'),
        title: 'Do you like baseball?',
        audioPrompt: 'appfiles/friends_bullying/option_like_baseball.mp3',
    };
    
    const optionLikeEat = {
        img: generateImageUrl('images/Module17Images/practice/what do you like to eat.png'),
        title: 'What do you like to eat?',
        audioPrompt: 'appfiles/friends_bullying/option_like_eat.mp3',
    };
    
    const optionRocksSticks = {
        img: generateImageUrl('images/Module17Images/practice/do you want to skip rocks or float sticks.png'),
        title: 'Do you want to skip rocks or float sticks?',
        audioPrompt: 'appfiles/friends_bullying/option_rock_stick.mp3',
    };
    
    const optionBandaid = {
        img: generateImageUrl('images/Module17Images/practice/get a bandaid.png'),
        title: 'Get a bandaid',
        audioPrompt: 'appfiles/friends_bullying/option_bandaid.mp3',
    };
    
    const optionListenMusic = {
        img: generateImageUrl('images/Module17Images/practice/listen to music.png'),
        title: 'Listen to music',
        audioPrompt: 'appfiles/friends_bullying/option_listen_music.mp3',
    };
    
    const optionGetNew = {
        img: generateImageUrl('images/Module17Images/practice/get them a new one.png'),
        title: 'Get them a new one',
        audioPrompt: 'appfiles/friends_bullying/option_get_new.mp3',
    };
    
    const optionLaugh = {
        img: generateImageUrl('images/Module17Images/practice/laugh at them.png'),
        title: 'Laugh at them',
        audioPrompt: 'appfiles/friends_bullying/option_laugh.mp3',
    };
    
    const optionSkateboard = {
        img: generateImageUrl('images/Module17Images/practice/do you like to skateboard.png'),
        title: 'Do you like to skateboard?',
        audioPrompt: 'appfiles/friends_bullying/option_skateboard.mp3',
    };

    const friendGreet = {
      prompt: 'If you see your friend at the playground, you should',
      audioPrompt: 'appfiles/friends_bullying/scenario_friend_greet.mp3',
      correctMatch: optionSmileHi,
      incorrectMatches: [optionFrown, optionIgnore],
    };

    const friendLike = {
      prompt: 'If you want to know what your friend likes, you can ask',
      audioPrompt: 'appfiles/friends_bullying/scenario_friend_likes.mp3',
      correctMatch: optionWhatLike,
      incorrectMatches: [optionWhySad, optionWhereGoing],
    };

    const friendNervous = {
      prompt:
        'If your friend tells you that he feels nervous when he gets up to bat, you should say',
      audioPrompt: 'appfiles/friends_bullying/scenario_friend_nervous.mp3',
      correctMatch: optionSorryNervous,
      incorrectMatches: [optionGiveUp, optionNeverNervous],
    };

    const friendBaseball = {
      prompt:
        'If you want to learn if your friend likes baseball, you can ask',
      audioPrompt: 'appfiles/friends_bullying/scenario_friend_baseball.mp3',
      correctMatch: optionLikeBaseball,
      incorrectMatches: [optionWhySad, optionWhereGoing],
    };

    const friendTrip = {
      prompt: 'If your friend trips and falls, you can',
      audioPrompt: 'appfiles/friends_bullying/scenario_friend_trip.mp3',
      correctMatch: optionBandaid,
      incorrectMatches: [optionIgnore, optionListenMusic],
    };

    const friendPlay = {
      prompt:
        'If you want to know what your friend wants to play, you can ask',
      audioPrompt: 'appfiles/friends_bullying/scenario_friend_play.mp3',
      correctMatch: optionRocksSticks,
      incorrectMatches: [optionWhySad, optionWhereGoing],
    };

    const friendNapkin = {
      prompt: 'If your friend drops their napkin, you can',
      audioPrompt: 'appfiles/friends_bullying/scenario_friend_napkin.mp3',
      correctMatch: optionGetNew,
      incorrectMatches: [optionGiveUp, optionIgnore],
    };

    const friendFoodLike = {
      prompt:
        'If you want to know what food your friend likes, you can ask',
      audioPrompt:
        'appfiles/friends_bullying/scenario_friend_food_like.mp3',
      correctMatch: optionLikeEat,
      incorrectMatches: [optionWhySad, optionWhereGoing],
    };

    const friendFall = {
      prompt: 'If your friend trips and falls, you should',
      audioPrompt: 'appfiles/friends_bullying/scenario_friend_fall.mp3',
      correctMatch: optionHelp,
      incorrectMatches: [optionLaugh, optionIgnore],
    };

    const friendSkateboard = {
      prompt:
        'If you want to know if your friend likes to skateboard, you can ask',
      audioPrompt:
        'appfiles/friends_bullying/scenario_friend_skateboard.mp3',
      correctMatch: optionSkateboard,
      incorrectMatches: [optionWhySad, optionWhereGoing],
    };

    const bullyMatch = [
      {
        prompt:
          'Someone is telling lies about you to other people. What should you do? Put the steps in order.',
        audioPrompt: 'appfiles/friends_bullying/scenario_bully_practice.mp3',
      },
      {
        prompt:
          'Someone tries to trip you every time you walk by. What should you do? Put the steps in order.',
        audioPrompt:
          'appfiles/friends_bullying/scenario_bully_baseball.mp3',
      },
      {
        prompt:
          'Someone laughs at you every time you try to skip a rock. What should you do? Put the steps in order.',
        audioPrompt: 'appfiles/friends_bullying/scenario_bully_pond.mp3',
      },
      {
        prompt:
          'Someone takes your food over and over again without asking. What should you do? Put the steps in order.',
        audioPrompt: 'appfiles/friends_bullying/scenario_bully_snack.mp3',
      },
      {
        prompt:
          'Someone keeps making fun of your skateboard. What should you do? Put the steps in order.',
        audioPrompt:
          'appfiles/friends_bullying/scenario_bully_skatepark.mp3',
      },
    ];

    const options = [
      [friendGreet, friendLike, bullyMatch[0]],
      [friendNervous, friendBaseball, bullyMatch[1]],
      [friendTrip, friendPlay, bullyMatch[2]],
      [friendNapkin, friendFoodLike, bullyMatch[3]],
      [friendFall, friendSkateboard, bullyMatch[4]],
    ];

    //create a random number between 0 and 4
    const randomNumber = Math.floor(Math.random() * 5);
    const selectedOption = options[randomNumber];


    for (let x = 0; x < document.getElementsByClassName("optionImage16").length; x++){
      document.getElementsByClassName("optionImage16")[x].style.borderColor  = 'black'
    }
    // Sets the crab video and audio thatt should play based on the emotion'
    setQuestion(false);
    setIntroSound('');
    setAnswerkey(null);
    setPractice(false);
    setIntroSound(getVideo(selectedOption[step].audioPrompt, login));
    if (step === 2) {
      setChangeText(selectedOption[step].prompt);
      initializeMatchGame();
    } 
    else {
      let numArray = [];
      numArray = [
        selectedOption[step].correctMatch,
        selectedOption[step].incorrectMatches[0],
        selectedOption[step].incorrectMatches[1],
      ];
      numArray = numArray
        .map((value) => ({ value, sort: Math.random() }))
        .sort((a, b) => a.sort - b.sort)
        .map(({ value }) => value);
      setOption1(numArray[0]);
      setOption2(numArray[1]);
      setOption3(numArray[2]);
      setKeyword(selectedOption[step].correctMatch.title);
      setChangeText(selectedOption[step].prompt);
      setQuestion(true);
      setPractice(true);
    }
  }

  const initializeMatchGame = () => {
    setInstruction(generateImageUrl('media/Freeplay/bullying_practice_intro.mp4'));
    const optionBullyStop = {
        img: generateImageUrl('images/Module17Images/practice/tell the bully to stop.png'),
        title: 'Tell the bully to stop',
        audioPrompt: 'appfiles/friends_bullying/option_tell_bully_stop.mp3',
    };
    const optionTellAdult = {
        img: generateImageUrl('images/Module17Images/practice/tell a safe adult.png'),
        title: 'Tell an adult',
        audioPrompt: 'appfiles/friends_bullying/option_tell_adult.mp3',
    };
    const optionWalkAway = {
        img: generateImageUrl('images/Module17Images/practice/walk away and stay away.png'),
        title: 'Walk away and stay away',
        audioPrompt: 'appfiles/friends_bullying/option_walk_away.mp3',
    };
    let numArray = [optionBullyStop, optionTellAdult, optionWalkAway];
    numArray = numArray
      .map((value) => ({ value, sort: Math.random() }))
      .sort((a, b) => a.sort - b.sort)
      .map(({ value }) => value);
    setMatchOptions([...numArray]);
    setMatchOptionsCopy([...numArray]);
    setDisplayIntro(true);
    setMatchGame(true);
  };

  async function reset() {
    setMatchGame(false)
    setOrder1(null)
    setOrder2(null)
    setOrder3(null)
    setOrder1Visibility('')
    setOrder2Visibility('')
    setOrder3Visibility('')
    setMatchOptions([...matchOptionsCopy])
    await sleep(1);
    setMatchGame(true)
  }

  const onHit1 = (e) => {
    console.log('onHit1', e);
    setOrder1(e.dragData.option);
    matchOptions[e.dragData.id] = null;
    setMatchOptions(matchOptions);
    setOrder1Visibility(e.dragData.id);
  };

  const onHit2 = (e) => {
    setOrder2(e.dragData.option);
    matchOptions[e.dragData.id] = null;
    setMatchOptions(matchOptions);
    setOrder2Visibility(e.dragData.id);
  };

  const onHit3 = (e) => {
    setOrder3(e.dragData.option);
    matchOptions[e.dragData.id] = null;
    setMatchOptions(matchOptions);
    setOrder3Visibility(e.dragData.id);
  };

  async function onDrag(option) {
    setAnimalVoice('');
    setAnimaTalk(false);
    //set a 500ms delay
    await sleep(500);
    setAnimalVoice(getVideo(option.audioPrompt, login));
    setAnimaTalk(true);
    setQuestion(false);
  }

  // Finds out what the user selected, and uses that as the current answer.
  async function setAnswer(option, index) {
    for (let x = 0; x < document.getElementsByClassName("optionImage16").length; x++){
      document.getElementsByClassName("optionImage16")[x].style.borderColor  = 'black'
    }
    document.getElementsByClassName("optionImage16")[index].style.borderColor  = 'yellow'
    setAnswerkey(option);
    setAnimalVoice('');
    setAnimaTalk(false);
    // await a 500ms delay
    await sleep(500);
    setAnimalVoice(await getVideo(option.audioPrompt, login));
    setAnimaTalk(true);
    setQuestion(false);
  }

  async function setAnswer17(option, index) {
    for (let x = 0; x < document.getElementsByClassName("optionImage").length; x++){
      document.getElementsByClassName("optionImage")[x].style.borderColor  = 'black'
    }
    if (document.getElementsByClassName("optionImage")[index]) {
      document.getElementsByClassName("optionImage")[index].style.borderColor  = 'yellow'
    }
  }

  const handleSubmit = () => {
    setAnimalVoice('');
    setAnimaTalk(false);
    
    // Check if the order is correct
    const isCorrect = order1.title === 'Tell the bully to stop' &&
                     order2.title === 'Walk away and stay away' &&
                     order3.title === 'Tell an adult';

    if (isCorrect) {
      const audio = new Audio(
        generateImageUrl('media/Module1Videos/button_accept_item.mp3')
      );
      audio.play();
      if(firstTime) setScore(3);
      props.onFinish();
    } else {
      let sound = new Audio(getVideo('appfiles/eye_contact/andrea_try_again.mp3', login));
      sound.play();
      let total = 3;
      
      if (order1.title !== 'Tell the bully to stop') {
        matchOptions[order1Visibility] = order1;
        setOrder1(null);
        --total;
      }
      if (order2.title !== 'Walk away and stay away') {
        matchOptions[order2Visibility] = order2;
        setOrder2(null);
        --total;
      }
      if (order3.title !== 'Tell an adult') {
        matchOptions[order3Visibility] = order3;
        setOrder3(null);
        --total;
      }
      
      if(firstTime) setScore(score+total);
      setFirstTime(false);
      setMatchOptions(matchOptions);
      
      (async () => {
        setMatchGame(false);
        await sleep(1);
        setMatchGame(true);
      })();
    }
  };

  // The HTML code for the match game
  return (
    <>
      {animalTalk && (
        <audio
          autoPlay
          onEnded={() => {
            setAnimaTalk(false);
          }}
        >
          <source src={animalVoice}></source>
        </audio>
      )}

      {!animalTalk && question && (
        <audio
          autoPlay
          onEnded={() => {
            setQuestion(false);
          }}
        >
          <source src={introSound}></source>
        </audio>
      )}

      {practice && (
        <div
          className='practiceSituation'
          style={{ backgroundImage: `url(${props.background})` }}
        >
          <img
            className='back-btn-ftb'
            src={Exit}
            onClick={() => {
              props.setDisplayPractice(false);
            }}
          ></img>
          <br/>
          <h2 className='practiceSituationHeader'>{titles[step]}</h2>
          <h3 className='practiceSituationQuestion'>{changeText}</h3>
          <img
            className='greenCheckPractice12'
            style={{opacity : answerkey ? 1 : 0, pointerEvents : answerkey ? "auto" : "none"}}
            src={greenCheck}
            alt=''
            onClick={async() => {
              setAnimalVoice('');
              setAnimaTalk(false);
              if (keyword === answerkey.title) {
                const audio = new Audio(
                  await generateImageUrl('media/Module1Videos/button_accept_item.mp3')
                );
                if(firstTime) setScore(score+1);
                audio.play();
                setStep(step + 1);
                setFirstTime(true);
              } else {
                setFirstTime(false)
                let sound = new Audio(getVideo('appfiles/eye_contact/andrea_try_again.mp3', login));
                sound.play();
                setAnswerkey(null);
              }
            }}
          />
          <div className='gameGrid16'>
            <div className='optionImage16' onClick={() => setAnswer(option1, 0)}>
              <div className='set16'>
                <img alt='' className='crabExpression16' src={option1.img} />
                {/* <h4 className='practiceText12'>{option1.title}</h4> */}
              </div>
            </div>
            <div className='optionImage16' onClick={() => setAnswer(option2, 1)}>
              <div className='set16'>
                <img alt='' className='crabExpression16' src={option2.img} />
                {/* <h4 className='practiceText12'>{option2.title}</h4> */}
              </div>
            </div>
            <div className='optionImage16' onClick={() => setAnswer(option3, 2)}>
              <div className='set16'>
                <img alt='' className='crabExpression16' src={option3.img} />
                {/* <h4 className='practiceText12'>{option3.title}</h4> */}
              </div>
            </div>
          </div>
        </div>
      )}

      {matchGame && (
        <>
        {displayIntro && 
        <div
          className='practiceSituation'
          style={{ backgroundImage: `url(${props.background})` }}
        >
          <div id='borderVideo'>
            <video
              id='record-video'
              autoPlay
              onEnded={() => {
                setDisplayIntro(false);
                setQuestion(true);
              }}
              playsInline
            >
              <source src={instruction} type='video/mp4'></source>
            </video>
          </div>
        </div>
        }
        {!displayIntro && <div
          className='practiceSituation'
          style={{ backgroundImage: `url(${props.background})` }}
        >
          <img
            className='back-btn-ftb'
            src={Exit}
            onClick={() => {
              if (props.onClose) {
                props.onClose();
              }
            }}
          ></img>
          <br />
          <br />
          <h2 className='practiceSituationHeader'>{titles[step]}</h2>
          <h3 className='practiceSituationQuestion'>{changeText}</h3>
          {(
            <img
              className='greenCheckPractice'
              style={{opacity : (order1 && order2 && order3)  ? 1 : 0, pointerEvents : (order1 && order2 && order3) ? "auto" : "none"}}
              src={greenCheck}
              alt=''
              onClick={handleSubmit}
            />
          )}
          <br />
          <div className='practiceSituationMatch'>
            <DropTarget
              targetKey=''
              onHit={(e) => {
                onHit1(e);
              }}
            >
            <h4>Step 1</h4>
              {
                <div className='practiceSituationBox'>
                  {order1 && (
                    <div
                      className='optionImage20'
                      onClick={() => setAnswer17(order1)}
                    >
                      <div className='set20'>
                        <img
                          alt=''
                          className='crabExpression20'
                          src={order1.img}
                        />
                      </div>
                    </div>
                  )}
                </div>
              }
            </DropTarget>
            <DropTarget
              targetKey=''
              onHit={(e) => {
                onHit2(e);
              }}
            >
            <h4>Step 2</h4>
              {
                <div className='practiceSituationBox'>
                  {order2 && (
                    <div
                      className='optionImage20'
                      onClick={() => setAnswer17(order2)}
                    >
                      <div className='set20'>
                        <img
                          alt=''
                          className='crabExpression20'
                          src={order2.img}
                        />
                      </div>
                    </div>
                  )}
                </div>
              }
            </DropTarget>
            <DropTarget
              targetKey=''
              onHit={(e) => {
                onHit3(e);
              }}
            >
            <h4>Step 3</h4>
              {
                <div className='practiceSituationBox'>
                  {order3 && (
                    <div
                      className='optionImage20'
                      onClick={() => setAnswer17(order3)}
                    >
                      <div className='set20'>
                        <img
                          alt=''
                          className='crabExpression20'
                          src={order3.img}
                        />
                      </div>
                    </div>
                  )}
                </div>
              }
            </DropTarget>
          </div>
          <div className='practiceSituationGrid'>
            <div className='grid-item20'>
              <DragDropContainer
                dragData={{ option: matchOptions[0], id: 0 }}
                targetKey=''
                onDragStart={() => onDrag(matchOptions[0])}
              >
                {matchOptions[0] && (
                  <div className='optionImage20'>
                    <div className='set20'>
                      <img
                        className='crabExpression20'
                        src={matchOptions[0].img}
                      />
                    </div>
                  </div>
                )}
              </DragDropContainer>
            </div>
            <div className='grid-item20'>
              <DragDropContainer
                dragData={{ option: matchOptions[1], id: 1 }}
                targetKey=''
                onDragStart={() => onDrag(matchOptions[1])}
              >
                {matchOptions[1] && (
                  <div className='optionImage20'>
                    <div className='set20'>
                      <img
                        className='crabExpression20'
                        src={matchOptions[1].img}
                      />
                    </div>
                  </div>
                )}
              </DragDropContainer>
            </div>
            <div className='grid-item20'>
              <DragDropContainer
                dragData={{ option: matchOptions[2], id: 2 }}
                targetKey=''
                onDragStart={() => onDrag(matchOptions[2])}
              >
                {matchOptions[2] && (
                  <div className='optionImage20'>
                    <div className='set20'>
                      <img
                        className='crabExpression20'
                        src={matchOptions[2].img}
                      />
                    </div>
                  </div>
                )}
              </DragDropContainer>
            </div>
          </div>
          <button
            style={{
              position: 'absolute',
              bottom: '0',
              width: '140px',
              marginLeft: '-70px',
              height: '60px',
              fontWeight: 'bold',
              backgroundColor: 'rgb(255, 105, 105)',
              borderColor: 'rgb(255, 105, 105)',
            }}
            onClick={() => {
              reset();
            }}
          >
            Reset
          </button>
        </div>}
        </>
      )}
    </>
  );
};

export default MatchGame;
